import { TalentBrowseCampaignConstraints, type TalentBrowseCampaignConstraintsProps } from "@/components/TalentBrowseCampaignConstraints";
import { BROWSE_SKELETON_COLUMNS, TalentBrowse, TalentBrowseTable, type TalentBrowseProps } from "@/components/talentBrowse";
import { useSkeletonPhases } from "@/hooks/useSkeletonPhases";

export type EditListBrowseProps = {
    isReady: boolean;
    isLoading: boolean;
    currency: TalentBrowseCampaignConstraintsProps["currency"];
    platforms: TalentBrowseCampaignConstraintsProps["platforms"];
    campaignType?: TalentBrowseCampaignConstraintsProps["campaignType"];
    browse?: TalentBrowseProps;
};

/** Left column: campaign constraints sibling, then TalentBrowse. */
export function EditListBrowse({ isReady, isLoading, currency, platforms, campaignType, browse }: EditListBrowseProps) {
    const phase = useSkeletonPhases(!isReady)
    if (phase === "showSkeleton") {
        return (
            <div className="p-4 lg:col-span-8">
                <TalentBrowseTable columns={BROWSE_SKELETON_COLUMNS} rows={[]} empty={null} isLoading />
            </div>
        );
    }
    if (phase === "showNothing") {
        return <div className="p-4 lg:col-span-8" />;
    }

    return (
        <div className="p-4 lg:col-span-8">
            <TalentBrowseCampaignConstraints
                currency={currency}
                platforms={platforms}
                campaignType={campaignType}
            />
            {browse ? (
                <TalentBrowse {...browse} isLoading={isLoading} />
            ) : null}
        </div>
    );
}
